import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { URL, colors } from "../utils/constant";
import DropDown2 from "./shared/DropDown2";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import {
  getLanguage,
  getLanguageNumber,
} from "../data/selector/language.selector";
import { useDispatch } from "react-redux";
import { setToken } from "../data/reducer/appState.reducer";
import { setClickableDate } from "../data/reducer/component.reducer";
import { setSelectedDate } from "../data/reducer/visits.reducer";
import { English } from "../Languages/en";
import { Spanish } from "../Languages/sp";
import {
  setLanguageNumber,
  setSelectedLanguage,
} from "../data/reducer/language.reducer";
import useLanguage from "../data/talons/Language/useLanguage";
import useInstruction from "../data/talons/Instruction/useInstruction";
import Dialogue from "./shared/Dialogue";
export default function VisitNavbar() {
  const dispatch = useDispatch();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropdownValue, setDropdownValue] = useState(1);
  const navigate = useNavigate();
  const Language = useSelector(getLanguage);
  const number = useSelector(getLanguageNumber);
  const { fetchInstruction, Instructions } = useInstruction();
  const [Open, setOpen] = useState(false);
  const [Alert, setAlert] = useState("");

  const handleIconClick = () => {};

  const { updateLanguages } = useLanguage();
  const Languages = Language.Language_Menu;

  useEffect(() => {
    // console.log(dropdownValue, "vkvkvkv");
    if (!dropdownValue) {
      // console.log("noneWnglish");
      dispatch(setSelectedLanguage(English));
    } else if (dropdownValue == 1) {
      // console.log("english");
      dispatch(setSelectedLanguage(English));
    } else if (dropdownValue == 2) {
      // console.log("spanish");
      dispatch(setSelectedLanguage(Spanish));
    }
  }, [dropdownValue]);

  return (
    <Box
      style={{ zIndex: 6, backgroundColor: "white" }}
      className="sidenav-closed sidenav"
    >
      <Dialogue open={Open} setOpen={setOpen} Alert={Alert} />
      <Box>
        <svg
          className="m-2 mb-5"
          width="39"
          height="39"
          viewBox="0 0 39 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.9906 36.6269C16.2019 36.6269 9.07492 29.4053 9.07492 20.5C9.07492 11.5947 16.1973 4.37315 24.9906 4.37315C31.0421 4.37315 36.3043 7.79683 38.9954 12.8341C35.9996 5.30858 28.7296 0 20.2316 0C9.05646 0 0 9.17659 0 20.5C0 31.8234 9.05646 41 20.2316 41C28.7296 41 36.0043 35.6914 39 28.1659C36.3089 33.2032 31.0468 36.6269 24.9953 36.6269H24.9906Z"
            fill="#09446C"
          />
          <path
            d="M22.34 9.87757C28.1997 9.87757 32.9538 14.631 32.9538 20.5C32.9538 26.369 28.2042 31.1224 22.34 31.1224C18.3046 31.1224 14.797 28.8686 13 25.5494C14.9972 30.5032 19.8469 34 25.5109 34C32.9584 34 39 27.958 39 20.5C39 13.042 32.9629 7 25.5109 7C19.8469 7 14.9972 10.4968 13 15.4506C14.7925 12.1314 18.3046 9.87757 22.34 9.87757Z"
            fill="#EA7224"
          />
        </svg>
      </Box>

      <Box className="icons-only mt-5 m-2">
        <Box
          display={"flex"}
          alignItems={"center"}
          sx={{ height: "40px" }}
          className="language data-icon"
        >
          <img
            id="languageSvg"
            alt="icon"
            className="p-1"
            src="./Images/language.svg"
            height="40px"
            width="40px"
            style={{
              backgroundColor: isDropdownOpen ? colors.grey2 : colors.white,
            }}
            onClick={() => {
              setIsDropdownOpen(!isDropdownOpen);
            }}
          />

          {isDropdownOpen && (
            <DropDown2
              onClick={(number) => {
                setIsDropdownOpen(false);
                setDropdownValue(number);
                dispatch(setLanguageNumber(number));
                updateLanguages(number);
                fetchInstruction();
              }}
              className={"dropdown"}
              values={Languages}
              selected={Language.LoginTitle.selectLang_label}
              label={Language.LoginTitle.selectLang_label}
              // handleLanguageChange={handleLanguageChange}
            />
          )}
        </Box>
        <Box className="data-icon">
          <img
            style={{
              backgroundColor:
                window.location.pathname === URL.patientDetails
                  ? colors.grey2
                  : "",
            }}
            alt="icon"
            className="p-1"
            src="./Images/user.svg"
            height="40px"
            width="40px"
            onClick={() => navigate(URL.patientDetails)}
          />
        </Box>
        <Box className="data-icon">
          <img
            style={{
              backgroundColor:
                window.location.pathname === URL.instruction
                  ? colors.grey2
                  : "",
            }}
            alt="icon"
            className="p-1"
            src="./Images/list.svg"
            height="40px"
            width="40px"
            onClick={() => navigate(URL.instruction)}
          />
        </Box>
        <Box className="data-icon">
          <img
            style={{
              backgroundColor:
                window.location.pathname === URL.visit ? colors.grey2 : "",
            }}
            alt="icon"
            className="p-1"
            src="./Images/calendar.svg"
            height="40px"
            width="40px"
            onClick={() => {
              navigate(URL.visit);
              dispatch(setSelectedDate(null));
            }}
          />
        </Box>
      </Box>

      <Box className="logoutBtn data-icon">
        <svg
          onClick={() => {
            setOpen(true);
            setAlert(Language?.AlertMsg.logout);
          }}
          className="m-3"
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="29"
          viewBox="0 0 181.000000 181.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,181.000000) scale(0.100000,-0.100000)"
            fill="#000000"
            stroke="none"
          >
            <path
              d="M249 1785 c-48 -31 -77 -69 -89 -116 -7 -25 -10 -296 -8 -786 3 -733
3 -749 23 -783 12 -19 40 -49 64 -67 l43 -33 469 0 c510 0 496 -1 551 57 48
51 58 90 58 236 0 137 -5 157 -42 157 -30 0 -38 -35 -38 -165 0 -139 -9 -170
-56 -195 -40 -22 -898 -22 -938 0 -58 30 -56 4 -56 815 0 679 2 749 17 775 9
16 27 33 40 39 16 7 173 11 477 11 l454 0 31 -35 31 -36 0 -174 c0 -144 3
-176 16 -189 18 -19 20 -19 45 -6 18 10 19 23 19 186 0 219 -11 252 -102 310
l-38 24 -467 -1 -468 0 -36 -24z"
            />
            <path
              d="M1487 1144 c-19 -20 1 -51 88 -138 52 -52 95 -97 95 -100 0 -3 -199
-5 -442 -6 -380 0 -445 -2 -458 -15 -11 -12 -12 -20 -4 -33 10 -16 48 -17 458
-22 l446 -5 -95 -95 c-52 -52 -95 -102 -95 -111 0 -21 24 -42 44 -37 20 4 286
268 286 283 0 6 -61 72 -135 146 -125 124 -167 153 -188 133z"
            />
          </g>
        </svg>
      </Box>
    </Box>
  );
}
